import type { ObjPathProxy } from "ts-object-path";
import type { MyPlannResourceDictionary } from "web_myplann/Infrastructure/Translations/ResourceDictionary";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { NotificationSettingKey } from "web_myplann/More/NotificationSettings/Types/NotificationSettingKey";

type ContractsToggleConfigItem = {
	key: NotificationSettingKey;
	labelResource: ObjPathProxy<MyPlannResourceDictionary, string>;
};

export const CONTRACTS_TOGGLE_CONFIG: ContractsToggleConfigItem[] = [
	{
		key: "contractEnd",
		labelResource: Resources.Settings.NotificationSettings.Items.EndOfContract,
	},
	{
		key: "fixationEnd",
		labelResource: Resources.Settings.NotificationSettings.Items.EndOfFixation,
	},
	{
		key: "contractAnniversary",
		labelResource:
			Resources.Settings.NotificationSettings.Items.AnniversaryOfContract,
	},
	{
		key: "shortTermContracts",
		labelResource:
			Resources.Settings.NotificationSettings.Items.AlertOnShortTermContracts,
	},
];
